import { render, staticRenderFns } from "./List-Solve-Shipment.vue?vue&type=template&id=4d240780"
import script from "./List-Solve-Shipment.vue?vue&type=script&lang=js"
export * from "./List-Solve-Shipment.vue?vue&type=script&lang=js"
import style0 from "./List-Solve-Shipment.vue?vue&type=style&index=0&id=4d240780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports